import React from 'react';
import ValidInputDroplistText from '../../../../core/components/validation/ValidInputDroplistText';
import { useGroupsCreateStore } from '../pagehooks/useGroupsCreateStore';
import { useGroupsCreateState } from './useGroupsCreateState';
import { useGroupsCreateModel } from './useGroupsCreateModel';
import Button from '../../../../core/components/Button';
import FormEdit from '../../../../core/components/form/FormEdit';
import FormFieldTitleBar from '../../../../core/components/form/FormFieldTitleBar';
import FormFieldRow from '../../../../core/components/form/FormFieldRow';
import MemberItem from './MemberItem';
import ScrollableListBox from '../../../../core/components/ScrollableListBox';

const FormMembersSection = (): JSX.Element => {
    const {
        state: { mode },
    } = useGroupsCreateStore();
    const { members, memberAddDropList } = useGroupsCreateState();
    const { memberAdd, memberRemove, memberChange, readOnlyModel, model } = useGroupsCreateModel();

    const typeFieldHasChanged = readOnlyModel.Type.val !== model.Type.val;
    const memTitleLen = members.length > 0 ? members.length.toString() : '';
    const subTitle =
        mode === 'CREATE' ? 'Create group before adding members.' : 'Member changes are applied immediately.';

    const memberList = members.map(mem => ({
        id: mem,
        name: mem,
    }));

    return (
        <FormEdit
            formName="grpEditMembers"
            cssName="grp-member-edit"
        >
            <FormFieldTitleBar title={`${memTitleLen} Group Member${members.length > 1 ? 's' : ''}`} />
            <p>{subTitle}</p>

            {mode === 'UPDATE' ? (
                <>
                    <FormFieldRow>
                        <ValidInputDroplistText
                            prop={memberAddDropList}
                            onChange={(_prop, val) => memberChange(val !== null ? `${val}` : val)}
                            disabled={typeFieldHasChanged}
                        >
                            {!!memberAddDropList.val && (
                                <Button
                                    cssName="btn-alt"
                                    onClick={memberAdd}
                                >
                                    ADD
                                </Button>
                            )}
                        </ValidInputDroplistText>
                    </FormFieldRow>
                    {members.length > 0 ? (
                        <ScrollableListBox
                            items={memberList}
                            listItemRenderer={(item: Record<string, any>, key: number) => (
                                <MemberItem
                                    key={key}
                                    name={item.name}
                                    onClick={memberRemove}
                                />
                            )}
                        />
                    ) : null}
                </>
            ) : null}
        </FormEdit>
    );
};

export default FormMembersSection;
